<template>
  <app-modal v-model="isDialogOpened"
             size="xs"
             :ok-loading="deleteEnvelopeTemplatesPending"
             :cancel-disabled="deleteEnvelopeTemplatesPending"
             :ok-text="$t('common.delete')"
             @ok="prepareDeleteEnvelopeTemplates"
             @cancel="closeDialog"
  >
    <template #title>
      <div class="d-flex align-center">
        <app-material-icon name="warning" filled class="mr-2" color="#eb8916" />
        <span v-t="{
            path: 'project.signing-checklist.envelope-templates.dialogs.ConfirmDeleteDialog.title',
            plural: envelopeTemplates.length,
            }"
        />
      </div>
    </template>
    <template #body>
      <template v-if="isSingleDelete">
        {{ $t('project.signing-checklist.envelope-templates.dialogs.ConfirmDeleteDialog.singleText', {envelopeTemplateName: envelopeTemplates[0].title}) }}
      </template>
      <template v-else>
        {{ $t('project.signing-checklist.envelope-templates.dialogs.ConfirmDeleteDialog.multipleText', {count: envelopeTemplates.length}) }}
      </template>
    </template>
  </app-modal>
</template>

<script>

import { mapActions, mapState } from 'vuex'

import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
export default {
  name: 'ConfirmDeleteDialog',
  mixins: [dialogMixin],
  props: {
    envelopeTemplates: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('envelopeTemplates', ['deleteEnvelopeTemplatesPending']),
    isSingleDelete () {
      return this.envelopeTemplates.length === 1
    },
  },
  methods: {
    ...mapActions('envelopeTemplates', ['DELETE_ENVELOPE_TEMPLATES']),
    async prepareDeleteEnvelopeTemplates () {
      try {
        await this.DELETE_ENVELOPE_TEMPLATES({
          ids: this.envelopeTemplates.map(e => e.id),
        })
        this.closeDialog()
      } catch (error) {
        toast.error(this.$t('project.signing-checklist.envelope-templates.dialogs.ConfirmDeleteDialog.deleteEnvelopeTemplateError', this.envelopeTemplates.length))
      }
    },
  },
}
</script>
